import { connect } from 'react-redux';
import ClearButton from 'components/ClearButton';
import { clearSearch, selectIsSearchActive } from '../modules/search';

export default connect(
  state => ({
    isActive: selectIsSearchActive(state),
  }),
  { clearSearch },
)(ClearButton);
